module.exports = new __parcel__URL__("insight-object-schema-attributes-skeleton.tpl.1117d25d.svg").toString();